import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8e1b3c20"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal z-50 fixed w-full h-full top-0 left-0 flex items-center justify-center" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "absolute w-full h-full bg-gray-900 opacity-50 modal-overlay" }, null, -1))
const _hoisted_3 = { class: "container-modal z-50 mx-auto overflow-y-auto bg-white rounded shadow-lg modal-container" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "text-white fill-current",
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 18 18"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z" })
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm" }, "(Esc)", -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = { class: "flex items-center justify-between pb-3" }
const _hoisted_8 = { class: "titleBold" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "text-black fill-current",
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 18 18"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z" })
], -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "grid grid-cols-1 gap-4 my-4" }
const _hoisted_12 = { class: "flex justify-end" }

import { computed, reactive, ref, watch } from 'vue'

import Input from '@/components/designSystem/Inputs/Input.vue'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'

import { storeToRefs } from 'pinia'
import { useCompanyStore } from '@/pinia-store/useCompanyStore'

import { useEscapeKey } from '@/utils/DOMEvents'

export interface CreatePolicyFormData {
  name: string
  companyId: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CreatePolicyModal',
  props: {
    modalActive: { type: Boolean },
    title: { default: 'Criar nova política' },
    loading: { type: Boolean, default: false }
  },
  emits: ["close", "submit"],
  setup(__props: any, { expose: __expose, emit: emits }) {





const { listCompanies } = storeToRefs(useCompanyStore())

useEscapeKey(() => {
  close()
})

const keyRender = ref(Math.random())

const error = reactive({
  name: false,
  companyId: false
})

const form = reactive({
  name: '',
  companyId: ''
})

const isValid = ref(false)

watch(form, () => {
  isValid.value = Object.values(error).every((e) => e !== true)
})

function validateName() {
  error.name = form.name.trim() === ''
}

function validateCompanyId() {
  error.companyId = !form.companyId
}

function validateAll() {
  validateName()
  validateCompanyId()
  isValid.value = Object.values(error).every((e) => e !== true)
}

function capitalizeFirstLetter(text: string): string {
  if (!text) return ''
  return text.toLowerCase().replace(/(^\w{1})|(\s+\w{1})/g, (letter) => letter.toUpperCase())
}

const companiesFormatted = computed(() => {
  return listCompanies.value.map((company) => ({
    title: capitalizeFirstLetter(company.title),
    value: String(company.value)
  }))
})

function handleSubmit() {
  validateAll()
  if (!isValid.value) return

  emits('submit', {
    name: form.name.trim(),
    companyId: form.companyId
  })
}

function close() {
  Object.keys(form).forEach((key) => {
    ;(form as Record<string, string>)[key] = ''
  })

  Object.keys(error).forEach((key) => {
    ;(error as Record<string, boolean>)[key] = false
  })

  keyRender.value = Math.random()
  emits('close')
}

__expose({ close })

return (_ctx: any,_cache: any) => {
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!

  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          onClick: close,
          class: "absolute md:inline flex top-0 right-0 z-50 flex-col items-center mt-4 mr-4 text-sm text-white cursor-pointer modal-close"
        }, _hoisted_6),
        (_openBlock(), _createElementBlock("div", {
          class: "px-6 py-4 text-left modal-content",
          key: keyRender.value
        }, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.title), 1),
            _createElementVNode("div", {
              class: "z-50 cursor-pointer modal-close",
              onClick: close
            }, _hoisted_10)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(Input, {
              isError: error.name,
              onChange: validateName,
              errorMessage: "Nome da política inválido",
              width: "100%",
              label: "Nome da política",
              modelValue: form.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.name) = $event)),
              required: "",
              "data-testid": "policy-name-input"
            }, null, 8, ["isError", "modelValue"]),
            _createVNode(_component_v_autocomplete, {
              modelValue: form.companyId,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.companyId) = $event)),
              color: "primary20",
              label: "Empresa",
              items: companiesFormatted.value,
              variant: "outlined",
              "data-testid": "policy-company-select"
            }, null, 8, ["modelValue", "items"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(OutlineButton, {
              onClick: close,
              class: "mr-4",
              text: "Cancelar",
              width: "120px",
              "data-testid": "cancel-policy-button"
            }),
            _createVNode(FilledButton, {
              loading: _ctx.loading,
              text: "Salvar",
              width: "100px",
              onClick: handleSubmit,
              class: "!bg-primary30",
              "data-testid": "submit-policy-button"
            }, null, 8, ["loading"])
          ])
        ]))
      ])
    ], 512), [
      [_vShow, _ctx.modalActive]
    ])
  ]))
}
}

})